import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-3 col-xm-12 col-sm-12" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-3 col-xm-12 col-sm-12" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col-md-3 col-sm-6col-xm-12 col-sm-12" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "col-md-3 col-xm-12 col-sm-12" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "table-responsive" }
const _hoisted_19 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }
const _hoisted_30 = { class: "dropdown" }
const _hoisted_31 = { class: "dropdown-menu" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  class: "modal fade",
  id: "create-task",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_36 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_37 = { class: "modal-content" }
const _hoisted_38 = { class: "modal-body px-4" }
const _hoisted_39 = { class: "row gy-2" }
const _hoisted_40 = { class: "col-md-4-3" }
const _hoisted_41 = { class: "col-md-4-3" }
const _hoisted_42 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.checkPermission('AddPaiement'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
              to: "/ajouter-paiement-recette"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Nouveau Paiement ", -1),
                _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Field, {
          name: "montant",
          modelValue: _ctx.lemontant,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lemontant) = $event)),
          "aria-disabled": "true",
          type: "text",
          disabled: "",
          class: "form-control text-center text-black shadow-none fs-md-15 text-black"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.valideEtape3)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getPoint())),
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "flaticon-download position-relative ms-5 fs-12" }, null, -1),
              _createTextVNode(" Exporter ", -1)
            ]))]))
          : _createCommentVNode("", true),
        (!_ctx.valideEtape3)
          ? (_openBlock(), _createElementBlock("button", _hoisted_6, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("span", {
                class: "spinner-grow spinner-grow-sm",
                role: "status",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)),
              _createVNode(_component_Field, {
                modelValue: _ctx.motCle,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.motCle) = $event)),
                name: "mot",
                type: "text",
                "aria-disabled": "true",
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Recherche par mot clé"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "mot",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Agent "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "agent",
                modelValue: _ctx.agent,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.agent) = $event)),
                class: "form-control shadow-none fs-md-15 text-black"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, {
                    options: _ctx.agentOptions,
                    searchable: true,
                    noResultText: "Aucun enregistrement trouvé",
                    placeholder: "Rechercher un percepteur"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "agent",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Date début "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "dateDebut",
                type: "date",
                modelValue: _ctx.dateDebut,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateDebut) = $event)),
                class: "form-control shadow-none fs-md-15 text-black"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "dateDebut",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Date fin "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "dateFin",
                modelValue: _ctx.dateFin,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dateFin) = $event)),
                type: "date",
                class: "form-control shadow-none fs-md-15 text-black"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "dateFin",
                class: "text-danger"
              })
            ])
          ])
        ])
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("table", _hoisted_19, [
          _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " # "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Usager "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Motif recette "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Taux "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Quantité "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " montant "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Place "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Acteur "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              }, " Actions ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retours, (ret, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_20, _toDisplayString(ret.refPaiement), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.format_date(ret.datePaiement, 'YYYY-MM-DD HH:ii')), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(ret.usager), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(ret.motif), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(ret.taux + " "+ ret.frequence), 1),
                _createElementVNode("td", _hoisted_25, _toDisplayString(ret.duree), 1),
                _createElementVNode("td", _hoisted_26, _toDisplayString(ret.montant), 1),
                _createElementVNode("td", _hoisted_27, _toDisplayString(ret.contrat ? ret.contrat?.codeemp?.ncode_emp + " "+ret?.contrat?.usagers : ""), 1),
                _createElementVNode("td", _hoisted_28, _toDisplayString(ret?.userCreation?.nomComplet), 1),
                _createElementVNode("td", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", {
                      class: "badge text-white bg-secondary fs-15 dropdown-toggle",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createTextVNode(" Actions "),
                      _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                    ], -1)),
                    _createElementVNode("ul", _hoisted_31, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.openNewWindow(ret)),
                          type: "button",
                          class: "dropdown-item d-flex align-items-center"
                        }, [...(_cache[14] || (_cache[14] = [
                          _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Reçu de paiement ", -1)
                        ]))], 8, _hoisted_32)
                      ]),
                      (_ctx.checkPermission('AnnulationPaiementRecette'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              "data-bs-target": "#create-task",
                              "data-bs-toggle": "modal",
                              onClick: ($event: any) => (_ctx.openModal(ret.refPaiement)),
                              class: "dropdown-item d-flex align-items-center"
                            }, [...(_cache[15] || (_cache[15] = [
                              _createElementVNode("i", { class: "flaticon-close lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Annulation ", -1)
                            ]))], 8, _hoisted_34)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h6", { class: "modal-title" }, "Voulez-vous annuler cette facture ?"),
              _createElementVNode("button", {
                type: "button",
                id: "close-modal",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_Form, {
                ref: "annulationForm",
                onSubmit: _ctx.soumettre,
                "validation-schema": _ctx.annulationSchema
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_Field, {
                        name: "id",
                        modelValue: _ctx.paiementId,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.paiementId) = $event)),
                        hidden: "",
                        class: "form-control shadow-none rounded-0 text-black"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block fw-semibold mb-10" }, [
                        _createTextVNode(" Motif"),
                        _createElementVNode("span", { class: "text-danger" })
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "motifAnnulation",
                        as: "textarea",
                        placeholder: "Entrer le motif d'annulation",
                        class: "form-control shadow-none rounded-0 text-black"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "motifAnnulation",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "modal-footer" }, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary"
                    }, "Annuler"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger",
                      "aria-label": "Close",
                      "data-bs-dismiss": "modal"
                    }, " Fermer ")
                  ], -1))
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}